export default __webpack_public_path__ + "static/media/640_store01-nl-web.a64e96a1.png";